(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SectorCategoryDialogController', SectorCategoryDialogController);

    SectorCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SectorCategory'];

    function SectorCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SectorCategory) {
        var vm = this;
        vm.sectorCategory = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:sectorCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.sectorCategory.id !== null) {
                SectorCategory.update(vm.sectorCategory, onSaveSuccess, onSaveError);
            } else {
                SectorCategory.save(vm.sectorCategory, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
